"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStringDate = void 0;
var weekdays = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
];
var months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
];
var parseStringDate = function (date) {
    var jsDate = new Date(date);
    var weekday = weekdays[jsDate.getDay()];
    var month = months[jsDate.getMonth()];
    var year = jsDate.getFullYear();
    return {
        weekday: weekday,
        month: month,
        day: jsDate.getDate(),
        year: year,
    };
};
exports.parseStringDate = parseStringDate;
